import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { FONT, MEDIA_QUERY, COLORS, COLORS3 } from '@zola/zola-ui/src/styles/emotion';
import { COLORS_BACKGROUND } from '@zola/zola-ui/src/styles/emotion/colors';
import CaretIcon from '@zola/zola-ui/src/components/SvgIcons/CaretV2';
import multiBg from 'assets/images/filters/multi.png';
import goldBg from 'assets/images/filters/gold.png';
import roseGoldBg from 'assets/images/filters/rose-gold.png';
import silverBg from 'assets/images/filters/silver.png';

export const Container = styled.div`
  ${MEDIA_QUERY.DESKTOP} {
    width: 196px;
  }
`;

export const DropdownSection = styled.div`
  padding-top: 20px;
  &:first-of-type {
    border-top: 1px solid ${COLORS_BACKGROUND.OUTLINE_GRAY};
  }
  border-bottom: 1px solid ${COLORS_BACKGROUND.OUTLINE_GRAY};
`;

export const SectionTitle = styled.div`
  padding-bottom: 20px;
  display: flex;
`;

export const DropdownTileRow = styled.div`
  margin-bottom: 20px;
  display: flex;
`;

export const DropdownTitle = styled.h3`
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  font-size: ${FONT.FONT_SIZE_REGULAR};
  display: inline;
  margin: 0;
  color: ${COLORS.BLACK};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const StyledChevronIcon = styled(CaretIcon)`
  color: ${COLORS3.BLACK_100};
  margin: 5px 20px 0 0;
`;

export const StyledOptionList = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (!visible ? 'none' : null)};
  .checkbox-list-item {
    margin-bottom: 24px !important;
  }
`;

export const checkboxFieldStyles = css`
  margin-bottom: 24px;
`;

export const ColorOptions = styled.div`
  display: flex;
`;

export const ColorIndicator = styled.div`
  height: 20px;
  width: 20px;
  background-size: contain;
  border-radius: 50%;
  margin-right: 8px;

  &.white {
    background-color: #ffffff;
    border: 2px solid #d9d9d9;
  }
  &.grey {
    background-color: #afb0ae;
  }
  &.blue {
    background-color: #0098f0;
  }
  &.green {
    background-color: #00b43b;
  }
  &.black {
    background-color: #1a170c;
  }
  &.red {
    background-color: #e30024;
  }
  &.yellow {
    background-color: #ffd530;
  }
  &.beige {
    background-color: #f1e8dd;
    border: 1px solid #d9d9d9;
  }
  &.pink {
    background-color: #ff8cbe;
  }
  &.orange {
    background-color: #ff9500;
  }
  &.purple {
    background-color: #8271c5;
  }
  &.multi {
    background-image: url(${multiBg});
  }
  &.gold {
    background-image: url(${goldBg});
  }
  &.rose_gold {
    background-image: url(${roseGoldBg});
  }
  &.silver {
    background-image: url(${silverBg});
  }
  &.brown {
    background-color: #805345;
  }
`;

export const ShowLess = styled(LinkV2)`
  margin-bottom: 24px;
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    margin-bottom: 45px;
  }
`;

export const MobileButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 12px 20px 40px;
  background-color: ${COLORS_BACKGROUND.LIGHT_GRAY};
  display: flex;
  align-items: center;
  justify-content: center;
  ${MEDIA_QUERY.DESKTOP} {
    display: none;
  }
`;

export const marginRight = css`
  margin-right: 8px;
`;
